module.exports = __webpack_public_path__ + "img/product_pressalit_bathe_a.2c475269.jpg";